exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doc-container {\n  width: 100%;\n  padding: 0 50px 40px 50px;\n}\n.doc-container h2.title {\n  border-left: 4px solid #008bff;\n  height: 20px;\n  line-height: 20px;\n  padding-left: 5px;\n  margin: 10px 0 20px 0;\n}\n.doc-container .sla-content {\n  color: #333;\n}\n.doc-container .sla-content h3 {\n  margin: 20px 0 10px 0;\n}\n.doc-container .sla-content p {\n  margin-bottom: 15px;\n}\n.doc-container .sla-content Table {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
